import type { IEditorContext } from "@/contexts/editor-context";
import {
  getEncryptedTeamIdFromPublicUserId,
  isPublicTeamId,
} from "@/core/common/types/public-team-id";
import { getEncryptedUserIdFromPublicUserId } from "@/core/common/types/public-user-id";
import type { AppUserQuotas } from "../common/types";
import { debugError } from "./print-utilts";
import { getCurrentTeamId } from "./team-utils";

export function getTeamQuotasFromContext(editorContextState: IEditorContext): AppUserQuotas | null {
  try {
    const { userQuotas, teamQuotas, publicUserId } = editorContextState;
    const currentTeamId = getCurrentTeamId();

    // If the current team id is the same as the current user id, then we default to the user's own quota
    if (
      getEncryptedTeamIdFromPublicUserId(currentTeamId) ===
      getEncryptedUserIdFromPublicUserId(publicUserId)
    ) {
      return userQuotas;
    }

    if (isPublicTeamId(currentTeamId) && teamQuotas?.id === currentTeamId) {
      return teamQuotas;
    }

    // debugLog("Using default user quotas: ", {
    //   publicUserId,
    //   currentTeamId,
    //   teamQuotas,
    // });

    return userQuotas;
  } catch (error) {
    debugError("Error getting team quotas from context state: ", error);

    return editorContextState?.userQuotas || null;
  }
}
